import { render, staticRenderFns } from "./appSwitcher.vue?vue&type=template&id=c84109cc&scoped=true"
import script from "./appSwitcher.vue?vue&type=script&lang=ts"
export * from "./appSwitcher.vue?vue&type=script&lang=ts"
import style0 from "./appSwitcher.vue?vue&type=style&index=0&id=c84109cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84109cc",
  null
  
)

export default component.exports